import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import HeatmapTable from '../HeatmapTable';
import ImageDownload from '../ImageDownload';
import DataDownload from '../DataDownload';
import NoResult from '../NoResult';

import './BarPlotResults.css';

const apiHost = process.env.REACT_APP_API_HOST;
const apiProto = process.env.REACT_APP_API_PROTOCOL;

class HeatMapResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParameters: {},
      heatmapData: null,
    };
  }

  componentDidMount() {
    this.updateSearchParams();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.hash !== prevProps.match.params.hash) {
      this.updateSearchParams();
    }
  }

  updateResultData(searchParameters) {
    const { match } = this.props;
    // TODO: need to check the input parameters. If we are using a list of genes,
    // then we need to use that list to generate the gene table next to the
    // results image, otherwise we need to query the data end point and grab
    // the top 10 genes to display.

    if (searchParameters.genes) {
      this.setState({ heatmapData: searchParameters.genes });
    } else if (searchParameters.comparison1) {
      const id = match.params.hash;
      const dataUrl = `${apiProto}://${apiHost}/nuclei/heatmap/data/${id}`;
      axios.get(dataUrl).then((response) => {
        this.setState({ heatmapData: response.data.slice(0, 10).map(n => n._row) });
      });
    }
  }

  updateSearchParams() {
    const { match } = this.props;
    const id = match.params.hash;
    const searchUrl = `${apiProto}://${apiHost}/search/${id}`;
    axios.get(searchUrl).then((response) => {
      this.setState({ searchParameters: response.data });
      this.updateResultData(response.data);
    });
  }

  render() {
    const { match } = this.props;
    const { heatmapData, searchParameters } = this.state;
    const id = match.params.hash;

    // use the id to fetch the search parameters.
    // also use it to place the result image in the page
    // as returned by the api.
    const plotUrl = `${apiProto}://${apiHost}/nuclei/heatmap/image/${id}`;
    const dataUrl = `${apiProto}://${apiHost}/nuclei/heatmap/data/${id}`;

    if (searchParameters.genes && searchParameters.genes.length < 1) {
      return <NoResult />;
    }

    return (
      <div className="row heatmap-results">
        <div className="col">
          <div className="card">
            <div className="card-header">
              Results
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h3>Parameters</h3>
                  <dl>
                    <dt>Cell Populations:</dt>
                    {searchParameters.ord ? (<dd>{searchParameters.ord.join(', ')}</dd>) :
                      (<dd>Loading...</dd>)}
                    {searchParameters.genes && ([
                      <dt key="label">Genes</dt>,
                      <dd key="value">{searchParameters.genes.join(', ')}</dd>,
                    ])}
                    {searchParameters.sort && ([
                      <dt key="label">Sort by</dt>,
                      <dd key="value">{searchParameters.sort}</dd>,
                    ])}
                    {searchParameters.de_mode && ([
                      <dt key="label">Differential Expresion Mode</dt>,
                      <dd key="value">{searchParameters.de_mode}</dd>,
                    ])}
                  </dl>
                </div>
              </div>
              <div className="row">
                <div className="col-lg">
                  <img alt="Heatmap of Results. Download below to get raw text data." src={plotUrl} />
                </div>
                <div className="col-lg">
                  { this.state.heatmapData && (<HeatmapTable results={heatmapData} params={searchParameters} />) }
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <ImageDownload id={id} plotUrl={plotUrl} />
                  <DataDownload id={id} dataUrl={dataUrl} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HeatMapResults.propTypes = {
  match: PropTypes.object.isRequired,
};

export default HeatMapResults;



// WEBPACK FOOTER //
// ./src/components/Nuclei/HeatMapResults.jsx